var _rect, _circle, _path, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 100,
    viewBox: "0 0 459 284",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 459,
    height: 284,
    rx: 33,
    fill: "#edf6f9",
    stroke: "transparent"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 83.5,
    cy: 79.5,
    r: 62.5,
    fill: "#8CB369"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M292 79.5C292 114.018 264.018 142 229.5 142C194.982 142 167 114.018 167 79.5C167 44.9822 194.982 17 229.5 17C264.018 17 292 44.9822 292 79.5Z",
    fill: "#644536"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 145.5,
    cy: 198.5,
    r: 62.5,
    fill: "#F4A259"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 302.5,
    cy: 198.5,
    r: 62.5,
    fill: "#5B8E7D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 375.5,
    cy: 79.5,
    r: 62.5,
    fill: "#BC4B51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b1bd7cf3c544853b9f077812ee0b07d1.svg";
export { ForwardRef as ReactComponent };